<template>
  <div>
    <main-menu></main-menu>

    <sidebar :fields="fields"></sidebar>

    <section class="wrapper scrollable">
      <user-menu></user-menu>

      <breadcrumb vuexModule="admin"></breadcrumb>

      <div class="mobile-control-buttons">
        <div class="col-md-6 col-lg-4 info-panel">
          <info-panel vuexModule="admin"></info-panel>
        </div>
      </div>

      <title-block vuexModule="admin"></title-block>

      <div class="row" v-if="ui.searchMode">
        <search-results></search-results>
      </div>

      <div class="row main-wrapper" v-show="!ui.searchMode">
        <instructions
          :title="$t('admin.rootEntryCreationIsDisabledForThisModule')"
          :text="$t('admin.startParentSelection')"
          v-if="
            admin.editorMode === 'default' &&
              admin.selectedModule.permission_control.crud.create &&
              !admin.parentSelectionActive
          "
        >
        </instructions>
        <instructions
          :title="$t('admin.parentEntrySelectionInProgress')"
          :text="$t('admin.pleaseSelectAParentEntryFromTheTreeMenu')"
          alert-class="alert-warning"
          v-if="
            admin.editorMode === 'default' &&
              admin.selectedModule.permission_control.crud.create &&
              admin.parentSelectionActive
          "
        >
        </instructions>

        <instructions
          :text="
            $t('admin.ifYouBelieveThisIsAnErrorPleaseContactTheAdministrator')
          "
          :title="
            $t(
              'admin.youHaveInsufficientPermissionsToCreateNewEntriesForThisModule'
            )
          "
          v-if="
            admin.editorMode === 'default' &&
              !admin.selectedModule.permission_control.crud.create
          "
        >
        </instructions>

        <admin-slot-above-entry-form></admin-slot-above-entry-form>

        <div
          v-if="admin.editorMode === 'edit' || admin.editorMode === 'create'"
          @click="onFirstInteract"
          @keydown="onFirstInteract"
        >
          <entry-form
            :fields="fields"
            :should-group-fields="true"
            :form-fields-reset-prop="formFieldsReset"
            vuexModule="admin"
          >
          </entry-form>
        </div>

        <admin-slot-below-entry-form></admin-slot-below-entry-form>

        <div v-if="admin.editorMode === 'search'">
          <div class="col-lg-12">
            <search
              :module-table-name="admin.selectedModule.table_name"
              v-on:selectEntry="navigateToEntry"
            ></search>
          </div>
        </div>

        <div
          class="col-md-6 col-lg-4 info-panel"
          v-if="admin.editorMode !== 'search'"
        >
          <div class="panel panel-default panel-block main-info mobile-panel">
            <div class="list-group">
              <div class="list-group-item text-center info-section-no-padding">
                <div
                  v-show="
                    admin.editorMode === 'edit' && admin.confirmDeleteEntry
                  "
                  class="create-entry-wrapper"
                >
                  <button
                    type="submit"
                    :disabled="
                      admin.editorMode === 'create' ||
                        admin.editorMode === 'default' ||
                        !admin.selectedModule.permission_control.crud.create ||
                        admin.selectedModule.type === 'single_entry'
                    "
                    @click="createNewEntry"
                    class="btn btn-default create-entry-button"
                  >
                    {{ $t('admin.createNewEntry') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-md-6 col-lg-4 info-panel desktop-info-panel"
          v-if="admin.editorMode !== 'search'"
        >
          <admin-slot-above-info-panel></admin-slot-above-info-panel>

          <info-panel vuexModule="admin"></info-panel>

          <admin-slot-below-info-panel></admin-slot-below-info-panel>

          <help-block></help-block>

          <admin-slot-below-help-block></admin-slot-below-help-block>
        </div>
      </div>
    </section>
    <assets></assets>
    <session-modal></session-modal>
    <SchedulePublishingModal :vuex-module="'admin'"></SchedulePublishingModal>
  </div>
</template>

<script>
import Admin from './Admin.js'
import SchedulePublishingModal from '../UserInterface/SchedulePublishingModal/SchedulePublishingModal'
export default Admin
</script>
